module.exports = __webpack_public_path__ + "img/01.9c4fffc0.gif";